<div class="login-photo-container">
  <div class="login-overlay-color">
    <div class="login-form-container">
      <div class="container-logo">
        <img class="login-logo" src="assets/logos/logo-agenda-group-7479.svg" />
      </div>
      <div class="text-center">
        <p>Olá, faça o login para acessar sua conta.</p>
      </div>

      <form
        [formGroup]="loginForm"
        (ngSubmit)="onSubmit()"
        *ngIf="!loading"
        class="form-login"
      >
        <div *ngIf="!isValid" class="login-invalid">
          <span class="material-icons-outlined login-invalid-icon">
            warning_amber
          </span>
          <span class="login-invalid-text">{{ errorMessage }}</span>
        </div>
        <!-- campo login -->
        <mat-form-field appearance="outline" class="input-form">
          <mat-label>Email</mat-label>
          <input
            matInput
            formControlName="email"
            type="email"
            autocomplete="email"
            readonly="false"
            class="borda"
          />
          <mat-error *ngIf="loginForm.get('email')?.hasError('email')"
            >Email inválido</mat-error
          >
          <mat-error *ngIf="loginForm.get('email')?.hasError('required')"
            >Informe o email</mat-error
          >
        </mat-form-field>

        <!-- Campo de senha -->
        <mat-form-field appearance="outline" class="input-form" color="primary">
          <mat-label>Senha</mat-label>
          <input
            matInput
            [type]="hide ? 'password' : 'text'"
            formControlName="password"
            autocomplete="password"
            data-recording-sensitive
          />
          <button
            mat-icon-button
            matSuffix
            (click)="hide = !hide"
            [attr.aria-label]="'Hide password'"
            [attr.aria-pressed]="hide"
            type="button"
          >
            <span>
              <img
                src="{{
                  hide
                    ? '../../../assets/icons/Group 1458.svg'
                    : '../../../assets/icons/Group 1457.svg'
                }}"
              />
            </span>
          </button>
          <mat-error *ngIf="loginForm.get('password')?.hasError('required')"
            >Informe a senha</mat-error
          >
          <mat-error *ngIf="loginForm.get('password')?.hasError('minlength')"
            >{{invalidMinPasswordErrorMessage}}
          </mat-error>
        </mat-form-field>
        <!-- botao para enviar formulário -->
        <button
          mat-raised-button
          [disabled]="loginForm.invalid || !loginForm.dirty"
          [className]="
            loginForm.invalid || !loginForm.dirty
              ? 'mat-focus-indicator btn-login-disabled mat-raised-button mat-button-base submit-disabled'
              : 'mat-focus-indicator btn-login mat-raised-button mat-button-base'
          "
        >
          Entrar
        </button>

        <a routerLink="/forgot-password" class="btn-forgot-password"
          >Esqueci minha senha</a
        >
      </form>
      <mat-progress-bar
        *ngIf="loading"
        mode="indeterminate"
        class="effect-mid"
      ></mat-progress-bar>
    </div>
  </div>
</div>
